import React from "react";
import { Counter } from "@/components/common/Counter";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";

export function Stats({ stats = {} }) {
  const { t } = useT();
  const items = [
    { label: t("stats.clients"), value: stats.clients_served || 1200, suffix: "+" },
    { label: t("stats.factories"), value: stats.factories_verified || 850, suffix: "+" },
    { label: t("stats.countries"), value: stats.countries_served || 47, suffix: "" },
    { label: t("stats.containers"), value: stats.containers_shipped || 9600, suffix: "+" },
  ];
  return (
    <section className="relative overflow-hidden bg-ink py-24 lg:py-28" data-testid="stats-section">
      <div className="absolute inset-0 grain opacity-10" />
      <div className="absolute -right-20 top-0 h-72 w-72 rounded-full bg-teal/20 blur-3xl" />
      <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-brand-blue/20 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-teal-light">{t("stats.overline")}</p>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            {t("stats.title")}
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {items.map((it, i) => (
            <Reveal key={it.label} delay={i * 0.1}>
              <div data-testid={`stat-${i}`}>
                <p className="font-heading text-5xl font-bold tracking-tight text-white lg:text-6xl">
                  <Counter to={it.value} suffix={it.suffix} />
                </p>
                <p className="mt-3 text-sm text-slate-400">{it.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
